import { z } from "zod";
import { conversionGetBaseSchema } from "./conversionGetBaseSchema";

export const madeAnyPurchaseConversionGetSchema = z.object({
  ...conversionGetBaseSchema.shape,
  event_type: z.literal("TrackedUserBehavior::MadeAnyPurchase"),
});
